import React, { useState, useEffect } from 'react';
import { FaArrowUp } from 'react-icons/fa';

const BackToTop = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setVisible(window.scrollY > 300);
        };
        window.addEventListener('scroll', handleScroll);
        handleScroll();
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    const scrollToTop = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <>
            <style>{`
                .obs-back-to-top {
                    position: fixed;
                    right: 28px;
                    bottom: 28px;
                    width: 46px;
                    height: 46px;
                    border-radius: 50%;
                    background: #534f4d;
                    color: #fff;
                    border: none;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    box-shadow: 0 8px 20px rgba(113, 161, 232, 0.4);
                    cursor: pointer;
                    z-index: 998;
                    opacity: 0;
                    visibility: hidden;
                    transform: translateY(12px);
                    transition: opacity 0.25s ease, transform 0.25s ease, visibility 0.25s ease, background 0.2s ease;
                }
                .obs-back-to-top.show {
                    opacity: 1;
                    visibility: visible;
                    transform: translateY(0);
                }
                .obs-back-to-top:hover {
                    background: #E52629;
                }
            `}</style>
            <button
                className={`obs-back-to-top ${visible ? 'show' : ''}`}
                onClick={scrollToTop}
                aria-label="Back to top"
            >
                <FaArrowUp size={16} />
            </button>
        </>
    );
};

export default BackToTop;